import { render, staticRenderFns } from "./DeliveryDetailsWrap.vue?vue&type=template&id=6028e498&scoped=true"
import script from "./DeliveryDetailsWrap.vue?vue&type=script&lang=js"
export * from "./DeliveryDetailsWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6028e498",
  null
  
)

export default component.exports